/* eslint-disable prefer-template */
import PageTitle from "../../../components/PageTitle";
// import Button from "../../../components/Button/Button";
import styles from "./Guardian.module.css";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import Badge from "../../../components/Badge";
import useValidator from "../../../hooks/useValidator";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
import Button from "../../../components/Button";
import { GuradianRole } from "../../../utils/DropDown";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react";

const STUDENTS_ENDPOINT = "/api/v1/students";
const GUARDIAN_ENDPOINT = "/api/v1/guardian";

const Ward = () => {
  const { id } = useParams();
  const classes = useStyles();
  const [wardData, setWardData] = useState([]);
  const [allstudents, setAllStudents] = useState([]);
  const [wardModal, setWarModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [item, setItem] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [wardValidator, showWardValidator] = useValidator();
  // const [deletingId, setDeletingId] = useState("");
  const [wardForm, setWardForm] = useState({
    wards: [
      {
        "student_id": "",
        "type": ""
      }
    ],
    guardian_id: id
  });

  const [wardArr, setWardArr] = useState([
    { student_id: "", type: "" }
  ]);

  const handleDeleteModal = (item) => {
    setItem(item);
    setDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const AddAdditionalWard = () => {
    const newWard = { student_id: "", type: "" };

    setWardForm((prev) => ({
      ...prev,
      wards: [...prev.wards, newWard]
    }));

    setWardArr((prev) => [...prev, newWard]);
  };

  const handleCloseWardModal = () => {
    setWardForm({
      wards: [{ student_id: "", type: "" }],
      guardian_id: id
    });

    // Reset the array used for rendering
    setWardArr([{ student_id: "", type: "" }]);

    setWarModal(!wardModal);
  };

  const getAllStudents = () => {
    httprequest.get(STUDENTS_ENDPOINT).then((res) => {
      setAllStudents(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleWardChange = (e, index, field) => {
    const { value } = e.target;

    setWardForm((prev) => {
      const updatedWards = prev?.wards?.map((ward, i) => i === index ? { ...ward, [field]: value } : ward
      );

      return { ...prev, wards: updatedWards };
    });

    setWardArr((prev) => prev.map((ward, i) => (i === index ? { ...ward, [field]: value } : ward))
    );
  };

  const handleDeleteWard = (index) => {
    setWardForm((prev) => ({
      ...prev,
      wards: prev.wards.filter((_, i) => i !== index)
    }));

    setWardArr((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCreateWard = () => {
    if (wardValidator.allValid()) {
      setIsCreating(true);
      httprequest
        .post(`${GUARDIAN_ENDPOINT}/wards`, wardForm)
        .then((res) => {
          setIsCreating(false);
          toast.success(res?.data?.message);
          handleCloseWardModal();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showWardValidator(true);
    }
  };
  const handleDeleteWardFromGuardian = (student_id) => {
    setIsDeleting(true);
    httprequest
      .delete(`${GUARDIAN_ENDPOINT}/wards/${id}/${student_id}`, wardForm)
      .then((res) => {
        setIsDeleting(false);
        toast.success(res?.data?.message);
        handleCloseDeleteModal();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      }).finally(() => {
        setIsDeleting(false);
      });
  };

  useEffect(() => {
    getAllStudents();
  }, []);

  useEffect(() => {
    httprequest.get(`${GUARDIAN_ENDPOINT}/wards/${id}`).then((res) => {
      setWardData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  }, []);

  return (
    <div>

      <PageTitle
        title="Your Wards"
        subtitle={
          <>

            <div className={`${styles.footer} flex align-items-center gap-5`}>
            </div>

          </>}
        button={
          <div className="flex gap-10">
            <Button
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              onClick={handleCloseWardModal}
              buttonName="Add Ward to Guardian"
            />
          </div>
        }
      />
      <Grid container spacing={4}>
        {wardData?.map((data, i) => {
          return (
            <Grid key={i} item lg={5} md={5} sm={12} xs={12}>
              <div>
                <div className={classes.wardContainer}>
                  <Icon
                    onClick={() => handleDeleteModal(data)}
                    icon="typcn:delete-outline"
                    width="24"
                    height="24"
                    style={{ color: "#f21717" }}
                  />
                </div>
                <div className="key-pair-container">
                  <div className="key-pair-content">
                    <p className="key-pair-name">Name</p>
                    <h3 className="key-pair-value"><Link to={`/users/students/${data?.student_id}`}>{data?.first_name + " " + data?.last_name}</Link></h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Class</p>
                    <h3 className="key-pair-value">{data?.class}</h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Age</p>
                    <h3 className="key-pair-value">{data?.age || "---"} Years</h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Email</p>
                    <h3 className="key-pair-value">{data?.email}</h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Contact</p>
                    <h3 className="key-pair-value">{data?.contact}</h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Guardian Type</p>
                    <h3 className="key-pair-value"><Badge status={data?.type} /></h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Gender</p>
                    <h3 className="key-pair-value">{data?.gender}</h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Admission Date</p>
                    <h3 className="key-pair-value">{data?.admission_date?.substring(0, 10)}</h3>
                  </div>
                  <div className="key-pair-content">
                    <p className="key-pair-name">Active Status</p>
                    <h3 className="key-pair-value"> <Badge status={data?.is_active} /></h3>
                  </div>
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid>
      {/* Delete Modal */}
      <Modal
        title="Remove a Ward From a Guardian"
        subtitle={
          <div>
                Are you sure you want to remove{" "}
            <span className="modal-name-highlight">
              {`${item?.first_name} ${item?.last_name}`}{" "}
            </span>
              Doing so will permanently delete this Ward.
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
                onClick={handleCloseDeleteModal}
              />
              <Button
                variant="danger"
                buttonName="Remove Ward"
                buttonSize="full"
                color="btndefault"
                onClick={() => handleDeleteWardFromGuardian(item?.student_id)}
                isLoading={isDeleting}
              />
            </div>
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
      {/* Add Ward */}
      <Modal
        title="Add Ward to Guardian"
        subtitle={
          <div>
            Manage and assign wards to their guardian
          </div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {wardArr?.map((item, index) => (
                  <div key={index}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup
                        label="Select Ward"
                        required
                        children={
                          <select value={item?.student_id} onChange={(e) => handleWardChange(e, index, "student_id")} name="student_id">
                            <option value="">--- Select ---</option>
                            {allstudents?.map((stn) => {
                              return (
                                <option key={stn?.student_id} value={stn?.student_id}>
                                  {`${stn?.student?.first_name} ${stn?.student?.last_name}`}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {wardValidator.message(
                        `Student ${index + 1}`,
                        item?.student_id,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup
                        label="Guardian Role"
                        required
                        children={
                          <select value={item?.type} onChange={(e) => handleWardChange(e, index, "type")} name="type">
                            <option value="">--- Select ---</option>
                            {GuradianRole?.map((role) => {
                              return (
                                <option key={role?.key} value={role?.key}>
                                  {role?.text}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {wardValidator.message(
                        `Type ${index + 1}`,
                        item?.type,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      {wardArr?.length > 1 ? (
                        <p
                          className="delete-input"
                          onClick={() => {
                            handleDeleteWard(index);
                          }}
                        >
                          <Icon icon="zondicons:minus-solid" />
                          Remove this ward
                        </p>
                      ) : null}
                    </Grid>
                  </div>
                ))}
              </Grid>
              <div
                className={`${classes.add} flex align-items-center`}
                onClick={AddAdditionalWard}
              >
                <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                <p>Add another ward</p>
              </div>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Add Ward(s)"
                onClick={handleCreateWard}
                isLoading={isCreating}
              />
            </div>
          </>
        }
        isopen={wardModal}
        closeModal={handleCloseWardModal}
      />
      {/* <ToastContainer /> */}
    </div>
  );
};

export default Ward;
